import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import './AboutUs.css';

const AboutUs = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="about" className="about-us" ref={ref}>
      <div className="container">
        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="section-title">About Me</h2>
            <p className="about-description">
              PrTechZone, a passionate freelance developer and designer
              dedicated to creating exceptional digital experiences. With years of
              expertise in mobile and web development, I transform complex ideas
              into elegant, user-friendly solutions.
            </p>
            <p className="about-description">
              My commitment to excellence drives me to stay at the forefront of
              technology, ensuring that every project I deliver is built with the
              latest tools and best practices. I believe in building long-term
              partnerships with my clients, understanding their vision, and
              delivering solutions that exceed expectations.
            </p>
            <div className="about-stats">
              <motion.div
                className="stat-item"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <div className="stat-number">50+</div>
                <div className="stat-label">Projects Delivered</div>
              </motion.div>
              <motion.div
                className="stat-item"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                <div className="stat-number">30+</div>
                <div className="stat-label">Happy Clients</div>
              </motion.div>
              <motion.div
                className="stat-item"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.6 }}
              >
                <div className="stat-number">5+</div>
                <div className="stat-label">Years Experience</div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            className="about-visual"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="visual-container">
              <div className="visual-shape shape-1"></div>
              <div className="visual-shape shape-2"></div>
              <div className="visual-shape shape-3"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;

